export default __webpack_public_path__ + "static/media/teacher.7887f598.png";